import type { RouteObject } from 'react-router-dom';

import { RequireSection, SectionIndexRedirect } from '@/shared/routing';

import { LoyaltyCardPoolPage } from './ui/pages/LoyaltyCardPoolPage';
import { LoyaltyCustomersPage } from './ui/pages/LoyaltyCustomersPage';
import { LoyaltyProgramPage } from './ui/pages/LoyaltyProgramPage';

/**
 * Loyalty feature subtree, mounted under the authenticated `AppLayout` shell.
 * `/loyalty` redirects to the day-to-day customer operations workspace; the
 * programme administration (model + tiers + rules) lives at `/loyalty/program`,
 * and the free-card pool at `/loyalty/pool`.
 *
 * <p>Two different permissions, not one. `/loyalty/customers` renders the customer
 * workspace with loyalty preselected — its list is a customer search, so it opens on
 * `customers.view` and the loyalty tab inside a selected customer gates itself on
 * `loyalty.view`. Programme administration and the card pool are loyalty's own and
 * need `loyalty.view` outright.
 */
export const loyaltyRoutes: RouteObject = {
  path: 'loyalty',
  children: [
    {
      // `/loyalty/customers` is a customer search, so a loyalty-only employee has to be sent to the
      // programme instead of bounced off a screen that asks for `customers.view`.
      index: true,
      element: <SectionIndexRedirect candidates={['loyalty', 'loyaltyProgram']} />,
    },
    {
      element: <RequireSection section="loyalty" />,
      children: [{ path: 'customers', element: <LoyaltyCustomersPage /> }],
    },
    {
      element: <RequireSection section="loyaltyProgram" />,
      children: [
        { path: 'program', element: <LoyaltyProgramPage /> },
        { path: 'pool', element: <LoyaltyCardPoolPage /> },
      ],
    },
    { path: '*', element: <SectionIndexRedirect candidates={['loyalty', 'loyaltyProgram']} /> },
  ],
};
